import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const aromaPopoverDefaultVariants = {
  "size": "middle"
}
const aromaPopoverCompoundVariants = []

const aromaPopoverSlotNames = [
  [
    "container",
    "aroma-popover__container"
  ],
  [
    "positioner",
    "aroma-popover__positioner"
  ],
  [
    "root",
    "aroma-popover__root"
  ]
]
const aromaPopoverSlotFns = /* @__PURE__ */ aromaPopoverSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, aromaPopoverDefaultVariants, getSlotCompoundVariant(aromaPopoverCompoundVariants, slotName))])

const aromaPopoverFn = memo((props = {}) => {
  return Object.fromEntries(aromaPopoverSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const aromaPopoverVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...aromaPopoverDefaultVariants, ...compact(variants) })

export const aromaPopover = /* @__PURE__ */ Object.assign(aromaPopoverFn, {
  __recipe__: false,
  __name__: 'aromaPopover',
  raw: (props) => props,
  variantKeys: aromaPopoverVariantKeys,
  variantMap: {
  "size": [
    "small",
    "middle",
    "large"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, aromaPopoverVariantKeys)
  },
  getVariantProps
})